"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var SelectButtonGrid_1 = __importDefault(require("atomicComponents/organisms/Button/SelectButtonGrid"));
var constants_1 = require("containersRechargly/Recharges/constants");
var general_1 = require("utils/general");
var GmailAutoFwd_1 = __importDefault(require("./GmailAutoFwd"));
var OtherEmailForwarding_1 = __importDefault(require("./OtherEmailForwarding"));
var OutlookAutoFwd_1 = __importDefault(require("./OutlookAutoFwd"));
var SelectEmailProvider = function (_a) {
    var emailProvider = _a.emailProvider, handleSelect = _a.handleSelect, vendor = _a.vendor;
    var options = (0, general_1.makeValueLabelArray)(constants_1.EMAIL_PROVIDERS).map(function (option) {
        var _a, _b, _c;
        return (__assign(__assign({}, option), { label: (_a = constants_1.EMAIL_PROVIDERS_LOGO[option.value]) === null || _a === void 0 ? void 0 : _a.label, logo: (_b = constants_1.EMAIL_PROVIDERS_LOGO[option.value]) === null || _b === void 0 ? void 0 : _b.logo, icon: (_c = constants_1.EMAIL_PROVIDERS_LOGO[option.value]) === null || _c === void 0 ? void 0 : _c.icon }));
    });
    var handleOnClick = function (provider) { return handleSelect(provider); };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ px: 3.5 }, { children: [emailProvider === 'Gmail' && (0, jsx_runtime_1.jsx)(GmailAutoFwd_1.default, { vendor: vendor }), emailProvider === 'Outlook' && (0, jsx_runtime_1.jsx)(OutlookAutoFwd_1.default, { vendor: vendor })] })), emailProvider === 'Other' && (0, jsx_runtime_1.jsx)(OtherEmailForwarding_1.default, {}), !emailProvider && ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, spacing: 1 }, { children: (0, jsx_runtime_1.jsx)(SelectButtonGrid_1.default, { options: options, handleClick: handleOnClick }) })))] }));
};
exports.default = SelectEmailProvider;
